import React, { useContext, useEffect, useRef, useState } from "react";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import {
    Avatar,
    Button,
    Input,
    Modal,
    Space,
    Table,
    Tag,
    Tooltip,
    Typography,
} from "antd";
import {
    DeleteOutlined,
    EditOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import moment from "jalali-moment";

const EventsTable = () => {
    // search
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`جستجو`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{
                        marginBottom: 8,
                        display: "block",
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        style={{
                            width: 90,
                        }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => {
                            handleReset(clearFilters);
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }}
                        style={{
                            width: 90,
                        }}
                    >
                        حذف فیلتر
                    </Button>

                    <Button
                        type="link"
                        onClick={() => {
                            close();
                        }}
                    >
                        بستن
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            dataIndex === "tags"
                ? record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => (searchedColumn === dataIndex ? text : text),
    });
    // context
    const { forceUpdate, setSelectedEventId, setForceUpdate, selectedEventId } =
        useContext(context);
    // state
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteModalOpen, setDeleteIsModalOpen] = useState(false);

    // useEffect
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Event/`)
            .then((res) => {
                setLoading(false);
                setTableData(res.data.result);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [forceUpdate]);

    // columns
    const columns = [
        {
            title: "عنوان",
            dataIndex: "title",
            width: "10%",
            ...getColumnSearchProps("title"),
        },
        {
            title: "تاریخ شروع",
            dataIndex: "links",
            key: "links",
            width: "10%",
            render: (_, { date }) => (
                <>
                    <Typography.Paragraph>
                        {moment(date.start.slice(0, 10), "YYYY/MM/DD")
                            .locale("fa")
                            .format("YYYY/MM/DD")}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "تاریخ پایان",
            dataIndex: "links",
            key: "links",
            width: "10%",
            render: (_, { date }) => (
                <>
                    <Typography.Paragraph>
                        {moment(date.end.slice(0, 10), "YYYY/MM/DD")
                            .locale("fa")
                            .format("YYYY/MM/DD")}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "لینک ها",
            dataIndex: "links",
            key: "links",
            width: "10%",
            render: (_, { links }) => (
                <>
                    {links.map((link) => {
                        return (
                            <Tooltip title={link.url}>
                                <Tag color="blue" key={link._id}>
                                    {link.name ? link.name : link.url.slice(0,8)}{" "}
                                    <i
                                        className={`fa ${link.icon
                                            .split(/(?=[A-Z])/)
                                            .map((word) => word.toLowerCase())
                                            .join("-")}`}
                                        style={{ fontSize: "10px" }}
                                    />
                                </Tag>
                            </Tooltip>
                        );
                    })}
                </>
            ),
        },
        {
            title: "تگ",
            dataIndex: "tags",
            key: "tags",
            ...getColumnSearchProps("tags"),
            width: "10%",
            render: (_, { tags }) => (
                <>
                    {tags.map((t) => {
                        return <Tag key={t}>{t.toUpperCase()}</Tag>;
                    })}
                </>
            ),
        },
        {
            title: "تعداد کامنت ها",
            width: "10%",
            dataIndex: "comment",
            render: (_, { comment }) => (
                <>
                    <Typography.Paragraph>
                        {comment.length}
                    </Typography.Paragraph>
                </>
            ),
        },

        {
            title: "عکس کاور",
            dataIndex: "coverPic",
            key: "coverPic",
            render: (_, { coverPic }) => (
                <Avatar
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                    src={<img src={`${coverPic?.address}`} alt="cover" />}
                />
            ),
        },
        {
            title: "عملیات",
            dataIndex: "button",
            key: "button",
            width: "10%",
            render: (text, record) => (
                <>
                    <Space style={{ width: "100%", direction: "ltr" }}>
                        <Button
                            onClick={() => {
                                setDeleteIsModalOpen(true);
                                setSelectedEventId(record._id);
                            }}
                            type="primary"
                            danger
                            shape="round"
                            icon={<DeleteOutlined />}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        />
                        <Tooltip title="ویرایش">
                            <Link to="/editEvent">
                                <Button
                                    onClick={() =>
                                        setSelectedEventId(record._id)
                                    }
                                    type="primary"
                                    icon={<EditOutlined />}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                />
                            </Link>
                        </Tooltip>
                        <Tooltip title="مشاهده کامنت ها">
                            <Link to="/eventComments">
                                <Button
                                    disabled={record.comment.length === 0}
                                    onClick={() =>
                                        setSelectedEventId(record._id)
                                    }
                                    type="primary"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    کامنت ها
                                </Button>
                            </Link>
                        </Tooltip>
                    </Space>
                </>
            ),
        },
    ];

    // functions
    const handleCancelModal = () => {
        setDeleteIsModalOpen(false);
    };
    const handleOkModal = () => {
        http.delete(`${config.parkopoloApi}/api/Event/${selectedEventId}`)
            .then(() => {
                setForceUpdate(11);
            })
            .catch((err) => {
                console.log(err);
                setForceUpdate(12);
            });
        setDeleteIsModalOpen(false);
        setForceUpdate(150);
    };
    return (
        <>
            <Table
                style={{ marginTop: "15px" }}
                size="small"
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                    showSizeChanger: false,
                }}
                bordered
                columns={columns}
                dataSource={tableData}
                scroll={{ x: true }}
                loading={loading}
                onRow={(record) => {
                    return {
                        onClick: () => setSelectedEventId(record._id),
                    };
                }}
            />
            <Modal
                title="حذف کامل"
                open={deleteModalOpen}
                onOk={handleOkModal}
                onCancel={handleCancelModal}
                okText="حذف"
            >
                <p>مطمئنی میخوای حذف کنی؟</p>
            </Modal>
        </>
    );
};

export default EventsTable;
